import { z } from "zod";

/**
 * Which header and footer a blog uses. Mirrors the Prisma `SiteTheme` enum. "brand" builds them
 * from the brand kit (name, logo, colours), so any brand can have a blog; the other two are the
 * hand-made First Round and Apex 25 designs.
 */
export const siteThemeSchema = z.enum(["firstround", "apex25", "brand"]);
export type SiteTheme = z.infer<typeof siteThemeSchema>;

/** A hostname as typed: lower case, no scheme, port, path or trailing dot. */
export const hostSchema = z
  .string()
  .trim()
  .toLowerCase()
  .max(253)
  .regex(
    /^(?=.{1,253}$)([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)*[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/,
    {
      message: "Use a bare host name like blog.example.com",
    },
  );
